// Static UI translations for the public worker page (instant, no LLM at runtime).
// Item titles/notes stay dynamic via the /translate endpoint; this only covers fixed chrome.
export const UI_STRINGS = {
  en: {
    punchList: "Punch List", progress: "Progress", item: "Item",
    banner: "Snap a proof photo on each item as you finish — that's all that's needed — then tap Send.",
    flagIssue: "Flag an issue", issueFlagged: "Issue flagged — tap to clear",
    issuePlaceholder: "What's wrong or what do you need? The sender will see this.",
    photoNeeded: "Photo needed", takeProof: "Take proof photo", addAnother: "Add another photo",
    uploadGallery: "Upload from gallery", doneCount: "{done} of {total} done",
    sendHint: "Tap send when you're finished (or partly done)", send: "Send",
    sentBack: "Sent back", sendAgain: "Send again",
    showOriginal: "Show original", sendProofBack: "Send proof back", complete: "Complete",
    bannerShort: "Add a photo to each item, then tap Send.", markNotDone: "Mark not done",
    photoUnavailable: "Photo unavailable — ask the sender to re-upload.",
    uploading: "Uploading…", removePhoto: "Remove photo", removeConfirm: "Remove this photo?",
    photoHint: "Tap to use camera or gallery", takePhoto: "Take photo", useCamera: "Use your camera",
    chooseGallery: "Choose from gallery", fromPhotos: "Pick from your photos", cancelBtn: "Cancel",
    nothingToSend: "Add at least one proof photo — or mark an item done, N/A, or flag an issue — before sending.",
    uploadFailedItem: "Photo didn't upload — tap the camera above to retry.",
    uploadFailedWarn: "{n} photo(s) didn't upload and won't be included. Retry them first if you can.",
  },
  es: {
    punchList: "Lista de pendientes", progress: "Progreso", item: "Ítem",
    banner: "Agrega una foto a cada ítem para mostrar que está hecho, luego toca Enviar.",
    flagIssue: "Marcar problema", issueFlagged: "Problema marcado — toca para quitar",
    issuePlaceholder: "¿Qué está mal o qué necesitas? El remitente lo verá.",
    photoNeeded: "Falta foto", takeProof: "Tomar foto de prueba", addAnother: "Agregar otra foto",
    uploadGallery: "Subir de galería", doneCount: "{done} de {total} listo",
    sendHint: "Toca Enviar cuando termines (o si vas a medias)", send: "Enviar",
    sentBack: "Enviado", sendAgain: "Enviar de nuevo",
    showOriginal: "Ver original", sendProofBack: "Enviar prueba de vuelta", complete: "Completo",
    photoUnavailable: "Foto no disponible — pide al remitente que la vuelva a subir.",
  },
  pt: {
    punchList: "Lista de pendências", progress: "Progresso", item: "Item",
    banner: "Adicione uma foto a cada item para mostrar que foi feito, depois toque em Enviar.",
    flagIssue: "Sinalizar problema", issueFlagged: "Problema sinalizado — toque para limpar",
    issuePlaceholder: "O que está errado ou o que você precisa? O remetente verá isto.",
    photoNeeded: "Foto necessária", takeProof: "Tirar foto de prova", addAnother: "Adicionar outra foto",
    uploadGallery: "Enviar da galeria", doneCount: "{done} de {total} feitos",
    sendHint: "Toque em Enviar quando terminar (ou parcialmente pronto)", send: "Enviar",
    sentBack: "Enviado", sendAgain: "Enviar de novo",
    showOriginal: "Mostrar original", sendProofBack: "Enviar prova de volta", complete: "Concluído",
    photoUnavailable: "Foto indisponível — peça ao remetente para reenviar.",
  },
  fr: {
    punchList: "Liste de réserves", progress: "Avancement", item: "Article",
    banner: "Ajoutez une photo à chaque article pour montrer que c’est fait, puis appuyez sur Envoyer.",
    flagIssue: "Signaler un souci", issueFlagged: "Souci signalé — touchez pour annuler",
    issuePlaceholder: "Qu’est-ce qui ne va pas ou que vous faut-il ? L’expéditeur le verra.",
    photoNeeded: "Photo requise", takeProof: "Prendre une photo preuve", addAnother: "Ajouter une autre photo",
    uploadGallery: "Importer depuis la galerie", doneCount: "{done} sur {total} faits",
    sendHint: "Touchez Envoyer quand vous avez fini (ou en partie)", send: "Envoyer",
    sentBack: "Envoyé", sendAgain: "Renvoyer",
    showOriginal: "Voir l’original", sendProofBack: "Envoyer la preuve", complete: "Terminé",
    photoUnavailable: "Photo indisponible — demandez à l’expéditeur de la renvoyer.",
  },
  vi: {
    punchList: "Danh sách việc", progress: "Tiến độ", item: "Hạng mục",
    banner: "Thêm ảnh cho từng mục để xác nhận xong, rồi nhấn Gửi.",
    flagIssue: "Báo lỗi", issueFlagged: "Đã báo lỗi — nhấn để xóa",
    issuePlaceholder: "Có gì sai hoặc bạn cần gì? Người gửi sẽ thấy.",
    photoNeeded: "Cần ảnh", takeProof: "Chụp ảnh chứng minh", addAnother: "Thêm ảnh khác",
    uploadGallery: "Tải từ thư viện", doneCount: "Xong {done}/{total}",
    sendHint: "Nhấn Gửi khi xong (hoặc làm dở)", send: "Gửi",
    sentBack: "Đã gửi", sendAgain: "Gửi lại",
    showOriginal: "Hiện bản gốc", sendProofBack: "Gửi ảnh xác nhận lại", complete: "Hoàn tất",
    photoUnavailable: "Không có ảnh — nhờ người gửi tải lại.",
  },
  zh: {
    punchList: "整改清单", progress: "进度", item: "项",
    banner: "给每项加一张照片证明已完成，然后点发送。",
    flagIssue: "标记问题", issueFlagged: "已标记问题 — 点此清除",
    issuePlaceholder: "哪里有问题或需要什么？发送方会看到。",
    photoNeeded: "需要照片", takeProof: "拍证明照", addAnother: "再加一张",
    uploadGallery: "从相册上传", doneCount: "已完成 {done}/{total}",
    sendHint: "做完后点发送（或先发部分）", send: "发送",
    sentBack: "已发送", sendAgain: "再次发送",
    showOriginal: "看原图", sendProofBack: "回传证明", complete: "完成",
    photoUnavailable: "照片不可用 — 请让发送方重新上传。",
  },
  ru: {
    punchList: "Пунч-лист", progress: "Прогресс", item: "Позиция",
    banner: "Добавьте фото к каждой позиции, чтобы показать, что готово, потом нажмите «Отправить».",
    flagIssue: "Сообщить о проблеме", issueFlagged: "Проблема отмечена — нажмите, чтобы снять",
    issuePlaceholder: "Что не так или что нужно? Отправитель это увидит.",
    photoNeeded: "Нужно фото", takeProof: "Сделать фото-подтверждение", addAnother: "Добавить ещё фото",
    uploadGallery: "Загрузить из галереи", doneCount: "{done} из {total} готово",
    sendHint: "Нажмите «Отправить», когда закончите (или частично готовы)", send: "Отправить",
    sentBack: "Отправлено", sendAgain: "Отправить снова",
    showOriginal: "Показать оригинал", sendProofBack: "Отправить подтверждение обратно", complete: "Готово",
    photoUnavailable: "Фото недоступно — попросите отправителя загрузить снова.",
  },
  ko: {
    punchList: "펀치 리스트", progress: "진행", item: "항목",
    banner: "각 항목에 완료 사진을 추가한 뒤 보내기를 누르세요.",
    flagIssue: "문제 표시", issueFlagged: "문제 표시됨 — 눌러 해제",
    issuePlaceholder: "무엇이 문제인가요? 무엇이 필요하신가요? 보낸 사람이 봅니다.",
    photoNeeded: "사진 필요", takeProof: "증빙 사진 찍기", addAnother: "사진 추가",
    uploadGallery: "갤러리에서 업로드", doneCount: "{done} / {total} 완료",
    sendHint: "끝나면(또는 일부만 끝나도) 보내기를 누르세요", send: "보내기",
    sentBack: "보냄", sendAgain: "다시 보내기",
    showOriginal: "원본 보기", sendProofBack: "증빙 다시 보내기", complete: "완료",
    photoUnavailable: "사진 없음 — 보낸 사람에게 다시 올리라고 하세요.",
  },
  pl: {
    punchList: "Lista usterek", progress: "Postęp", item: "Pozycja",
    banner: "Dodaj zdjęcie do każdej pozycji, żeby pokazać, że zrobione, potem stuknij Wyślij.",
    flagIssue: "Zgłoś problem", issueFlagged: "Problem zgłoszony — stuknij, by usunąć",
    issuePlaceholder: "Co jest nie tak albo czego potrzebujesz? Nadawca to zobaczy.",
    photoNeeded: "Potrzebne zdjęcie", takeProof: "Zrób zdjęcie potwierdzające", addAnother: "Dodaj kolejne zdjęcie",
    uploadGallery: "Dodaj z galerii", doneCount: "{done} z {total} gotowe",
    sendHint: "Stuknij Wyślij, gdy skończysz (albo jeśli część jest gotowa)", send: "Wyślij",
    sentBack: "Wysłano", sendAgain: "Wyślij ponownie",
    showOriginal: "Pokaż oryginał", sendProofBack: "Wyślij potwierdzenie", complete: "Gotowe",
    photoUnavailable: "Zdjęcie niedostępne — poproś nadawcę o ponowne wysłanie.",
  },
  ht: {
    punchList: "Lis Tach", progress: "Pwogrè", item: "Atik",
    banner: "Ajoute yon foto pou chak atik pou montre li fini, apre sa peze Voye.",
    flagIssue: "Make yon pwoblèm", issueFlagged: "Pwoblèm make — peze pou retire",
    issuePlaceholder: "Kisa k pa bon oswa kisa ou bezwen? Moun k voye a va wè sa.",
    photoNeeded: "Foto nesesè", takeProof: "Pran foto prèv", addAnother: "Ajoute yon lòt foto",
    uploadGallery: "Telechaje nan galri", doneCount: "{done} sou {total} fini",
    sendHint: "Peze Voye lè w fini (oswa si w fè yon pati)", send: "Voye",
    sentBack: "Voye", sendAgain: "Voye ankò",
    showOriginal: "Montre orijinal", sendProofBack: "Voye prèv tounen", complete: "Konplè",
    photoUnavailable: "Foto pa disponib — mande moun k voye a telechaje ankò.",
  },
};

export function makeT(lang) {
  const base = UI_STRINGS.en;
  const cur = UI_STRINGS[lang] || {};
  return (key) => cur[key] || base[key] || key;
}
